import { GetFileExtension } from "../../utilities/utilityService";
import { PDF_VIEWER } from "../../routes/routes";

export const StatusBadge = ({ status }) => {
  const map = {
    active: {
      dot: "bg-green-500",
      pill: "bg-green-100 text-green-800",
      label: "Active",
    },
    inactive: {
      dot: "bg-gray-400",
      pill: "bg-gray-100 text-gray-600",
      label: "Inactive",
    },
  };
  const s = map[status] || map.inactive;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${s.pill}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};

export const typeBadge = ({ type }) => {
  const typeMap = {
    header: { label: "BNR", bg: "bg-purple-100 text-purple-700" },
    aside: { label: "ASI", bg: "bg-green-100 text-green-800" },
    terms: { label: "T&C", bg: "bg-blue-100 text-blue-700" },
  };

  const { label, bg } = typeMap[type] ?? {
    label: "?",
    bg: "bg-gray-100 text-gray-600",
  };

  return (
    <span
      className={`shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-lg text-xs font-bold ${bg}`}
    >
      {label}
    </span>
  );
};

export const AssetRow = ({ asset, onRemove, isLoading }) => {
  let ext = GetFileExtension(asset.fileName);

  return (
    <li className="flex items-center justify-between py-2 border-b border-gray-100 dark:border-gray-700 last:border-0">
      <div className="flex items-center gap-2 min-w-0">
        {typeBadge({ type: asset.type })}
        <div className="min-w-0">
          <a
            target="_blank"
            rel="noreferrer"
            href={
              ext.toLowerCase() === "pdf"
                ? `${PDF_VIEWER}?file=${asset.url}`
                : asset.url
            }
            className="text-xs font-medium text-gray-900 dark:text-white truncate"
          >
            {asset.fileName}
          </a>
          <p className="text-xs text-gray-400">{asset.addedBy}</p>
        </div>
      </div>
      {/*   <div className="flex gap-1.5 shrink-0 ml-2">
         <Button
          size="xs"
          color="failure"
          onClick={() => onRemove(asset)}
          disabled={isLoading}
        >
          Remove
        </Button>
      </div> */}
    </li>
  );
};

export const FILTERS = ["all", "active", "inactive"];

export const sortByDate = (data) => {
  if (!data) return [];

  return Object.values(data).sort((a, b) => {
    const getTime = (d) =>
      typeof d.createdAt === "object"
        ? d.createdAt.seconds
        : new Date(d.createdAt).getTime();

    return getTime(b) - getTime(a);
  });
};

export const getUniqueFileName = (name, assets = []) => {
  if (!assets.some((a) => a.fileName === name)) return name;
  let i = 1;
  while (true) {
    const candidate = `${name}_copy${i > 1 ? `_${i}` : ""}`;
    if (!assets.some((a) => a.fileName === candidate)) return candidate;
    i++;
  }
};

export const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
